<input type="checkbox" class="cmx-slide-toggle" [checked]="checked" [disabled]="disabled" [class.error]="error">
<label for="checkbox">
    <ng-content></ng-content>
</label>